var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10C10 8.89543 10.8954 8 12 8H13.1716C13.702 8 14.2203 7.79372 14.6893 7.54596C15.8064 6.95586 18.4694 6 24 6C29.5306 6 32.1936 6.95586 33.3107 7.54596C33.7797 7.79372 34.298 8 34.8284 8H36C37.1046 8 38 8.89543 38 10V36C38 37.1046 37.1046 38 36 38H12C10.8954 38 10 37.1046 10 36V10ZM18 9C18 8.44772 18.4477 8 19 8H29C29.5523 8 30 8.44772 30 9C30 9.55228 29.5523 10 29 10H19C18.4477 10 18 9.55228 18 9ZM14 16C13.4477 16 13 16.4477 13 17V23C13 23.5523 13.4477 24 14 24H34C34.5523 24 35 23.5523 35 23V17C35 16.4477 34.5523 16 34 16H14ZM18.5 32C18.5 33.6569 17.1569 35 15.5 35C13.8431 35 12.5 33.6569 12.5 32C12.5 30.3431 13.8431 29 15.5 29C17.1569 29 18.5 30.3431 18.5 32ZM32.5 35C34.1569 35 35.5 33.6569 35.5 32C35.5 30.3431 34.1569 29 32.5 29C30.8431 29 29.5 30.3431 29.5 32C29.5 33.6569 30.8431 35 32.5 35Z",
    fill: "#039BE5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 37,
    width: 5,
    height: 4,
    rx: 1,
    fill: "#039BE5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 37,
    width: 5,
    height: 4,
    rx: 1,
    fill: "#039BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default ForwardRef;